import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'#FightCoronavirus'}
      {'    '}
      {/*<Link color="inherit" href="https://material-ui.com/">*/}
      {/*  Your Website*/}
      {/*</Link>{' '}*/}
      {new Date().getFullYear()}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));

export default function Footer() {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <Typography variant="h6" align="center" gutterBottom>
        Thank you for working
      </Typography>
      <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
        I really appreciate all you’re doing!
      </Typography>
      <Copyright />
    </footer>
  );
}
